<template>
  <div class="offcanvas offcanvas-end oc-bottom" data-bs-scroll="true" tabindex="-1" id="notificationArea" aria-labelledby="notificationAreaLabel">
    <div class="offcanvas-header notification-header bg-primary text-light form-check form-check-notification mb-0">
      <h2 class="offcanvas-title fs-5 ms-3" id="notificationAreaLabel">メール通知</h2>
      <span class="mt-1 ms-10">
        <input class="form-check-input" type="checkbox" id="hideReadMails" v-model="unreadChecked" @change="toggleUnreadCheckbox">
        <label class="form-check-label" for="hideReadMails">未読のみ</label>
      </span>
      <span type="button" class="btn-close btn-close-white text-reset" data-coreui-dismiss="offcanvas" aria-label="Close"></span>
    </div>
    <notification-area-body :unread-checked="unreadChecked" />
  </div>
</template>

<script>
import NotificationAreaBody from '@/views/atoms/NotificationAreaBody'
import { mapMutations } from 'vuex'

export default {
  name: "NotificationArea",
  components: {
    NotificationAreaBody,
  },
  data() {
    return {
      unreadChecked: false,
    }
  },
  methods: {
    ...mapMutations('mail_history_index', [
      'setCurrentPage',
      'setCurrentPageCountUp',
    ]),
    toggleUnreadCheckbox() {
      this.$store.commit('mail_history_index/resetData');
      this.$store.commit('mail_history_index/setIsReadSearchValue', this.unreadChecked ? 0 : null);
      this.setCurrentPage({ value: 1 });
      this.$store.dispatch('mail_history_index/load').then(() => {
        this.setCurrentPageCountUp();
      }).catch(() => this.$root.failApi());
    }
  },
}
</script>

<style scoped>
  .form-check-input:checked[type=checkbox] {
    background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='rgba(1,65,77,0.87)' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>");
    background-color: white;
  }
</style>
